import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("dsa_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("dsa_token");
  }
}

const saved = localStorage.getItem("dsa_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export function apiErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
